// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G-PYa","left":"styles_left__15adR"};